export default {
  routes: [
    {
      name: 'directory',
      path: '/directory',
      component: () => import('./views/TheDirectory.vue'),

    }
  ]
}
